<template>
  <Transition name="page-loader-fade">
    <div
      v-if="isLoading"
      class="PageLoader"
      role="status"
      aria-live="polite"
      aria-label="Pagina laden"
    >
      <div
        ref="loaderAnimationRef"
        class="loader-animation"
      />
    </div>
  </Transition>
</template>

<script lang="ts" setup>
  import lottie, { type AnimationItem } from 'lottie-web'
  import pageLoaderAnimationData from '~/assets/SpeeldoosVught_Pageloader_lottie.json'

  const { isLoading } = useLoadingIndicator()
  const loaderAnimationRef = ref<HTMLElement | null>(null)
  let loaderAnimation: AnimationItem | null = null

  watch(isLoading, async (loading) => {
    if (!loading) {
      loaderAnimation?.destroy()
      loaderAnimation = null
      return
    }

    await nextTick()
    if (!loaderAnimationRef.value) return

    loaderAnimation = lottie.loadAnimation({
      container: loaderAnimationRef.value,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: pageLoaderAnimationData,
    })
  })

  onUnmounted(() => {
    loaderAnimation?.destroy()
  })
</script>

<style lang="scss" scoped>
  .PageLoader {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background-color: $background;
      opacity: 0.5;
    }
  }

  .loader-animation {
    position: relative;
    width: 18rem;
    max-width: 60vw;
    aspect-ratio: 600 / 440;
  }

  .page-loader-fade-enter-active,
  .page-loader-fade-leave-active {
    transition: opacity 0.25s ease;
  }

  .page-loader-fade-enter-from,
  .page-loader-fade-leave-to {
    opacity: 0;
  }
</style>
